import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';
import { HELP_CENTER_LINKS } from '../helpCenterLinks';

export const monitoringAlertDetailSteps = [
  {
    element: '[data-onboarding="alert-header-tabs"]',
    popover: {
      title: 'Alert View Tabs',
      description:
        `The <a href="${HELP_CENTER_LINKS.sites}" target="_blank" class="text-lime underline">site</a> and company are shown here, and you can switch between views. Event shows key snapshots, while Live View streams the camera in real time.`,
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-info-panel"]',
    popover: {
      title: 'Alert Information',
      description:
        'All key alert details appear here, including location, contacts, site instructions, and Quill analysis. Review these before responding.',
      side: 'right' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-snapshot-viewer"]',
    popover: {
      title: 'Alert Snapshot',
      description:
        'Snapshots show what caused the alert. Step through the frames to confirm what you are seeing and decide whether to escalate, resolve, or gather more information.',
      side: 'top' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-snapshot-toggles"]',
    popover: {
      title: 'Snapshot Controls',
      description:
        'Use these tools to analyse the image. Show or hide the activation zone, highlight detected objects, display bounding boxes, or download the snapshot for reporting.',
      side: 'left' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="alert-timeline"]',
    popover: {
      title: 'Event Timeline',
      description:
        'The timeline shows events in time order. Red marks are people, blue are vehicles, and grey marks are events Quill viewed and discarded. Select any marker to jump to that point.',
      side: 'top' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-jump-button"]',
    popover: {
      title: 'Jump to Next Unviewed Event',
      description:
        "Jump to the next unviewed event. The progress bar shows how many events you've checked, and the button changes to All viewed when you're finished. Press n to jump quickly.",
      side: 'top' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-auto-button"]',
    popover: {
      title: 'Event Visibility Toggle',
      description:
        'Switch between Auto mode, which shows only events that need your attention, and All mode, which shows every event. Press v to toggle.',
      side: 'top' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-workflow-panel"]',
    popover: {
      title: 'Disposition Workflow',
      description:
        'Use this panel to respond to the alert. Assign it, add notes, trigger calls, or close it out. Work through the steps so all actions are recorded.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
];


export const monitoringAlertDetailRoutes: RouteConfig[] = [
  {
    id: 'alert-detail',
    processName: ONBOARDING_KEYS.alertDetail,
    match: (path: string) => path.startsWith('/alert/'),
    steps: monitoringAlertDetailSteps,
  },
];

